import React, {
  Component
} from 'react';

import Modal from '../../components/UI/Modal/Modal';
import Error from '../../components/UI/Error/Error';
import Box from '../Box/Box';
import { AiFillWarning } from "react-icons/ai";

const withErrorHandler = (WrappedComponent, axios) => {
  return class extends Component {
    state = {
      error: null
    }

    componentWillMount() {
      this.reqInterceptor = axios.interceptors.request.use(req => {
        this.setState({
          error: null
        });
        return req;
      });
      this.resInterceptor = axios.interceptors.response.use(res => res, message => {
        if (message?.config?.url?.includes('getIOTNetworkDevices')) {
          return Promise.reject(message);
        }
        this.setState({
          error: message
        });
      });
    }

    componentWillUnmount() {
      axios.interceptors.request.eject(this.reqInterceptor);
      axios.interceptors.response.eject(this.resInterceptor);
    }

    errorConfirmedHandler = () => {
      this.setState({
        error: null
      });
    }

    render() {
      return (
        <Box>
          <Modal
            show={this.state.error}
            modalClosed={this.errorConfirmedHandler}>
              {this.state.error ? <Error /> : null}
            {/* {this.state.error && (
              <div style={{ padding: "0.5rem" }}>
                <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
                    <AiFillWarning color="#F93875" size={40} />
                    <h2>Error {this.state.error?.response?.status || ''}</h2>
                </div>
                <p style={{ marginBottom: "2rem" }}>
                    UpStream service not available. Please refresh the page and try again. If error persists, please contact your supervisor.
                </p>
              </div>
            )} */}
          </Modal>
          <WrappedComponent {...this.props} />
        </Box>
      );
    }
  }
}

export default withErrorHandler;
